export default __webpack_public_path__ + "static/media/multi-and-dynamic-cake-banner-mob.bd93c4de.jpg";